import { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

const Barcode = ({ value = "351101821719", height = 40, width = 1.4, displayValue = false }) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) {
      try {
        JsBarcode(ref.current, value, {
          format: "CODE128",
          width,
          height,
          displayValue,
          margin: 0,
          background: "#ffffff",
          lineColor: "#0a0a0a",
        });
      } catch (e) {
        // ignore
      }
    }
  }, [value, height, width, displayValue]);
  return <svg ref={ref} />;
};

export default Barcode;
